import { useNavigate } from "react-router-dom";

import { text } from "../text";
import { utils } from "../utils";
import { theme } from "../constants";
import { BackIcon } from "../constants/icons";

type Props = {
  title?: string;
  goBack?: boolean;
  style?: React.CSSProperties;
  themeColor?: "dark" | "light";
  showBottomShadow?: boolean;
};

export const Header: React.FC<Props> = ({
  title,
  style,
  goBack,
  themeColor = "light",
  showBottomShadow = false,
}) => {
  const navigate = useNavigate();

  const renderGoBack = (): JSX.Element | null => {
    const canGoBack = window.history.length > 1;

    if (goBack && canGoBack) {
      return (
        <div
          style={{
            height: "100%",
            padding: "0 20px",
            cursor: "pointer",
            userSelect: "none",
            ...utils.flexCenter(),
          }}
          onClick={() => navigate(-1)}
        >
          <BackIcon
            color={themeColor === "dark" ? "white" : "black"}
            size={25}
          />
        </div>
      );
    }

    return null;
  };

  const renderTitle = (): JSX.Element => {
    return (
      <text.H5
        style={{
          textAlign: "center",
          color: themeColor === "dark" ? theme.colors.white : "black",
        }}
      >
        {title}
      </text.H5>
    );
  };

  return (
    <header
      style={{
        ...style,
        backgroundColor:
          themeColor === "dark"
            ? theme.colors.backgroundColorDark
            : theme.colors.white,
        boxShadow: themeColor === "light" ? "0 2px 2px -2px gray" : "",
      }}
    >
      {renderGoBack()}
      {renderTitle()}
    </header>
  );
};
